const PopularData = [
    {
      id: 1,
      image: "images/pop1.jpeg",
      country: "Givng Back",
      name: "Health Clinic",
      price: "Free medical checkup",
    },
    {
      id: 2,
      image: "images/pop2.jpeg",
      country: "Mexico",
      name: "Food Drive",
      price: "Food and provisions donations",
    },
    {
      id: 3,
      image: "images/pop3.jpeg",
      country: "United States",
      name: "Counselling and Support",
      price: "Seminars and counselling",
    },
    {
      id: 4,
      image: "images/slider-2.jpeg",
      country: "Thailand",
      name: "Giving Back",
      price: "Support for widows",
    },
    {
      id: 5,
      image: "images/slider-4.jpeg",
      country: "Vietnam",
      name: "Securing the future",
      price: "Childrens wellfare and education",
    },
    {
      id: 6,
      image: "images/empowerment.webp",
      country: "Mexico",
      name: "Youth Empowerment",
      price: "Supporting the youth by skill learning",
    },
    {
      id: 7,
      image: "images/pop8.jpeg",
      country: "United States",
      name: "Financial Support",
      price: "Supporting local business",
    },
    {
      id: 8,
      image: "images/widows.jpeg",
      country: "Thailand",
      name: "Widows Support",
      price: "Helping widows with the right support system",
    },
  ]
  
  export default PopularData